import { Spinner } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { removeNotificationBanner } from './actions';
import './style.scss';
const NotificationBanner = withRouter(props => {
  const dispatch = useDispatch();
  const { status, msg, id, htmlMsg, redirect, history } = props;
  const removeBanner = () => removeNotificationBanner(dispatch, id);
  return (
    <div className={`notification-banner notification-theme-${status} flex items-center`}>
      <div>
        {status === 'inProgress' && <Spinner animation="border" size="sm" style={{ marginRight: '8px' }} />}{' '}
        {htmlMsg ? (
          htmlMsg
        ) : isEmpty(redirect) ? (
          <span dangerouslySetInnerHTML={{ __html: msg }}></span>
        ) : (
          <span
            style={{ cursor: 'pointer' }}
            dangerouslySetInnerHTML={{ __html: msg }}
            onClick={() => {
              history.push(redirect.path, {
                breadCrumbStack: redirect.stack,
                mode: redirect.mode,
              });
            }}></span>
        )}
      </div>
      {(status === 'success' || 'error') && (
        <div className="hover:cursor-pointer">
          <X size={16} onClick={removeBanner} />
        </div>
      )}
    </div>
  );
});

export const NotificationContainer = () => {
  const notifications = useSelector(state => state.notification.array);
  // if (isEmpty(notifications)) return null;
  // console.log(notifications, 'notifications');
  return (
    <div id="notification-container">
      {notifications.map(data => (
        <NotificationBanner key={data} {...data} />
      ))}
    </div>
  );
};
